import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './PremiumCelebration.css';

const PremiumCelebration = ({ onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete?.();
    }, 4000); // Animation duration

    return () => clearTimeout(timer);
  }, [onComplete]);

  const confetti = Array.from({ length: 50 }).map((_, i) => (
    <motion.div
      key={i}
      className="confetti"
      initial={{
        x: Math.random() * window.innerWidth,
        y: -20,
        scale: Math.random() * 0.5 + 0.5,
      }}
      animate={{
        y: window.innerHeight + 20,
        rotate: Math.random() * 360 * 2,
      }}
      transition={{
        duration: Math.random() * 2 + 2,
        ease: "linear",
        repeat: Infinity,
      }}
      style={{
        background: `hsl(${Math.random() * 360}, 80%, 60%)`,
        left: `${Math.random() * 100}%`,
      }}
    />
  ));

  return (
    <motion.div
      className="premium-celebration"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {confetti}
      <motion.div
        className="celebration-content"
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", duration: 0.8 }}
      >
        <motion.div
          className="celebration-icon"
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
        >
          ⭐
        </motion.div>
        <motion.h2
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Welcome to Premium!
        </motion.h2>
        <motion.p
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          Enjoy unlimited generations and premium features
        </motion.p>
      </motion.div>
    </motion.div>
  );
};

export default PremiumCelebration;
